import { ForcedState, useForcedState } from '../../contexts/forced-state-context';
import React, { useCallback, useRef } from 'react';
import { TextArea as TPATextArea, TextAreaTheme } from 'wix-ui-tpa/cssVars';
import classNames from 'classnames';
import { classes } from '../../ui/text-area-field/text-area-field-wut.st.css';
export const TextAreaInputWUT = _ref => {
  let {
    label,
    placeholder,
    required,
    value,
    onChange,
    onFocus,
    onBlur,
    disabled = false,
    inputId,
    hasError,
    ariaDescribedBy
  } = _ref;
  const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
  const textAreaRef = useRef(null);
  const handleChange = useCallback(event => {
    const newValue = event.target.value;
    onChange(newValue);
  }, [onChange]);
  return /*#__PURE__*/React.createElement(TPATextArea, {
    id: inputId,
    error: hasError,
    newErrorMessage: true,
    className: classNames(classes.textArea, classes.theme, {
      [classes.error]: hasError,
      [classes.hover]: forcedHover
    }),
    ariaLabel: label ?? '',
    value: value ? String(value) : '',
    onChange: handleChange,
    onFocus: onFocus,
    onBlur: onBlur,
    disabled: disabled,
    placeholder: placeholder,
    theme: TextAreaTheme.Box,
    "aria-describedby": ariaDescribedBy,
    "aria-invalid": hasError,
    required: required,
    ref: textAreaRef
  });
};
//# sourceMappingURL=text-area-input-wut.js.map